import React from 'react'
import './about.scss'
import Button from '../../buttons/Button'
import { motion } from 'framer-motion'
const About = () => {
  return (
    <motion.div className='about'
        initial={{opacity:0}}
        animate={{opacity:1}} 
        transition={{type:"tween", duration:.5}}
     >
      <div className="wrapper">

         <div className="left">
         <img src="https://res.cloudinary.com/raiusl/image/upload/v1687875635/anne-peres-plsF6obTgms-unsplash_ctmmqj.jpg" alt="" />
         </div>
         <div className="right">
         <div className="content">
          <h3>Creative Independent Web Developer based in Australia</h3>
           <p>I'm web designer, and I'm very passionate and dedicated to my work. With 20 years experience as a professional web developer, I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the design process, from discussion and collaboration.</p>
         </div>
         <Button name={"Download CV"}/>
         </div>
      </div>
    </motion.div>
  )   
}

export default About